import * as React from 'react';

import { Helmet } from 'react-helmet-async';
import { useLoaderData } from 'react-router-dom';

import type { NoticeDto } from 'types';

import { NoticesInfo, PublicNoticesHeader } from './components';

type PublicNoticesLoaderData = {
  notices: NoticeDto[];
};

export default function PublicNotices() {
  const data = useLoaderData() as PublicNoticesLoaderData | undefined;

  const { notices = [] } = data ?? {};

  return (
    <React.Fragment>
      <Helmet>
        <title>فوتر | کاشی لند</title>
      </Helmet>
      <PublicNoticesHeader />
      <div className='rounded bg-white'>
        <NoticesInfo notices={notices} />
      </div>
    </React.Fragment>
  );
}
